import { render, staticRenderFns } from "./PrintVenta.vue?vue&type=template&id=0389fc96&scoped=true&"
import script from "./PrintVenta.vue?vue&type=script&lang=js&"
export * from "./PrintVenta.vue?vue&type=script&lang=js&"
import style0 from "./PrintVenta.vue?vue&type=style&index=0&id=0389fc96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0389fc96",
  null
  
)

export default component.exports